export default {
	about: '',
	mission: '',
	vesion: ''
}